(function() {
  'use strict';

  // Get product form and product-form custom element
  const productForm = document.querySelector('.product-form');
  const productFormElement = document.querySelector('product-form');
  if (!productForm || !productFormElement) {
    return;
  }

  // Find modal by checking all recommended accessories modals
  const modal = document.querySelector('.recommended-accessories-modal');
  if (!modal) {
    return; // No modal, exit early
  }

  // Extract product ID from modal ID
  const modalId = modal.id;
  const productId = modalId.replace('RecommendedAccessoriesModal-', '');

  const addToCartButton = productForm.querySelector('.product-form__add-button[data-action="add-to-cart"]');
  const actionButton = modal.querySelector('.recommended-accessories-action-button');
  const checkboxes = modal.querySelectorAll('.recommended-accessory-checkbox');
  const warrantyRadios = modal.querySelectorAll('.warranty-radio');
  
  let originalFormSubmit = null;
  let shouldShowModal = false;

  // Function to update button state based on selections (accessories OR warranty)
  function updateButtonState() {
    if (!actionButton) return;
    
    const hasAccessorySelections = Array.from(checkboxes).some(checkbox => checkbox.checked);
    const hasWarrantySelection = Array.from(warrantyRadios).some(radio => radio.checked);
    const hasSelections = hasAccessorySelections || hasWarrantySelection;
    
    if (hasSelections) {
      // Products or warranty selected - show Continue button styled like Add to Cart
      actionButton.textContent = 'Continue';
      actionButton.className = 'recommended-accessories-action-button button button--primary';
    } else {
      // No selections - show Skip Offer button styled like Get Better Price
      actionButton.textContent = 'Skip Offer';
      actionButton.className = 'recommended-accessories-action-button recommended-accessories-skip-button';
    }
  }

  // Listen for checkbox changes
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateButtonState);
  });

  // Listen for warranty radio button changes
  warrantyRadios.forEach(radio => {
    radio.addEventListener('change', updateButtonState);
  });

  // Initialize button state
  updateButtonState();

  // Fix shield icon size to match text line height
  function fixShieldIconSize() {
    const warrantySection = modal.querySelector('.protect-your-gear-section');
    if (warrantySection) {
      const header = warrantySection.querySelector('.protect-your-gear-header');
      if (header) {
        const svgInHeader = header.querySelector('svg');
        if (svgInHeader) {
          // The viewBox is "0 0 22 24", so aspect ratio is 22:24
          // Set to 24px width, 26px height for a bigger icon
          const targetHeight = 26;
          const targetWidth = 24;
          
          svgInHeader.setAttribute('width', targetWidth.toString());
          svgInHeader.setAttribute('height', targetHeight.toString());
          svgInHeader.style.width = targetWidth + 'px';
          svgInHeader.style.height = targetHeight + 'px';
          svgInHeader.style.maxWidth = targetWidth + 'px';
          svgInHeader.style.maxHeight = targetHeight + 'px';
          svgInHeader.style.display = 'block';
          svgInHeader.style.flexShrink = '0';
          svgInHeader.style.verticalAlign = 'middle';
        }
      }
    }
  }

  // Fix icon size when modal opens
  const iconSizeObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        if (modal.getAttribute('aria-hidden') === 'false') {
          setTimeout(fixShieldIconSize, 100);
        }
      }
    });
  });
  
  iconSizeObserver.observe(modal, {
    attributes: true,
    attributeFilter: ['aria-hidden', 'open']
  });
  
  // Also run immediately if modal is already visible
  setTimeout(fixShieldIconSize, 500);

  // Intercept add to cart button click - use capture phase to run before other handlers
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function(e) {
      // Check if modal exists and has accessories
      if (modal && checkboxes.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        // Open the modal
        modal.showModal();
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('is-locked');
        return false;
      }
    }, true); // Use capture phase
  }

  // Also intercept form submission as backup
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      if (modal && checkboxes.length > 0 && !shouldShowModal) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        // Open the modal
        modal.showModal();
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('is-locked');
        return false;
      }
    }, true);
  }

  // Store original button content for restoration
  let originalButtonContent = actionButton ? actionButton.innerHTML : '';

  // Function to set button loading state
  function setButtonLoading(isLoading) {
    if (!actionButton) return;
    
    if (isLoading) {
      // Store current content before switching to loading state
      originalButtonContent = actionButton.innerHTML;
      actionButton.setAttribute('disabled', 'disabled');
      actionButton.style.pointerEvents = 'none';
      actionButton.style.opacity = '0.7';
      actionButton.innerHTML = '<span style="display: inline-flex; align-items: center; gap: 8px; justify-content: center;"><svg class="icon icon--search-loader" style="width: 16px; height: 16px; animation: spinnerRotation 0.7s linear infinite;" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity=".4" d="M23.8589104 1.05290547C40.92335108-3.43614731 58.45816642 6.79494359 62.94709453 23.8589104c4.48905278 17.06444068-5.74156424 34.59913135-22.80600493 39.08818413S5.54195825 57.2055303 1.05290547 40.1410896C-3.43602265 23.0771228 6.7944697 5.54195825 23.8589104 1.05290547zM38.6146353 57.1445143c13.8647142-3.64731754 22.17719655-17.89443541 18.529879-31.75914961-3.64743965-13.86517841-17.8944354-22.17719655-31.7591496-18.529879S3.20804604 24.7494569 6.8554857 38.6146353c3.64731753 13.8647142 17.8944354 22.17719655 31.7591496 18.529879z"></path><path d="M1.05290547 40.1410896l5.80258022-1.5264543c3.64731754 13.8647142 17.89443541 22.17719655 31.75914961 18.529879l1.5264543 5.80258023C23.07664892 67.43614731 5.54195825 57.2055303 1.05290547 40.1410896z"></path></svg>Adding to Cart...</span>';
    } else {
      actionButton.removeAttribute('disabled');
      actionButton.style.pointerEvents = '';
      actionButton.style.opacity = '';
      // Restore button state based on current checkbox selections
      updateButtonState();
    }
  }

  // Handle action button click
  if (actionButton) {
    actionButton.addEventListener('click', function() {
      const hasAccessorySelections = Array.from(checkboxes).some(checkbox => checkbox.checked);
      const hasWarrantySelection = Array.from(warrantyRadios).some(radio => radio.checked);
      const hasSelections = hasAccessorySelections || hasWarrantySelection;
      
      // Get selected warranty
      const selectedWarrantyRadio = Array.from(warrantyRadios).find(radio => radio.checked);
      const selectedWarranty = selectedWarrantyRadio ? {
        id: selectedWarrantyRadio.value,
        quantity: 1
      } : null;
      
      // If no selections, skip (same as old skip button behavior)
      if (!hasSelections) {
        // Set button to loading state
        setButtonLoading(true);
        
        // Close modal and proceed with normal add to cart
        modal.close();
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('is-locked');
        shouldShowModal = false;
        
        // Submit the form normally
        if (productForm) {
          // Dispatch loading start
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          
          const formData = new FormData(productForm);
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          })
          .then(response => {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            return response.json();
          })
          .then(() => {
            // Restore button state
            setButtonLoading(false);
            // Deselect all checkboxes and warranty radios
            checkboxes.forEach(checkbox => {
              checkbox.checked = false;
            });
            warrantyRadios.forEach(radio => {
              radio.checked = false;
            });
            updateButtonState();
            
            // Get current variant from variant picker script tag or form ID
            let currentVariant = null;
            const variantPicker = productForm.querySelector('variant-picker');
            if (variantPicker) {
              const variantScript = variantPicker.querySelector('script[data-variant]');
              if (variantScript) {
                try {
                  currentVariant = JSON.parse(variantScript.textContent);
                } catch (e) {
                  // Fallback to variant ID from form
                  const variantId = formData.get('id');
                  currentVariant = variantId ? { id: parseInt(variantId) } : null;
                }
              }
            } else {
              // Fallback: get variant ID from form
              const variantId = formData.get('id');
              currentVariant = variantId ? { id: parseInt(variantId) } : null;
            }
            
            // Dispatch product:added event from productFormElement so it bubbles properly
            productFormElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: currentVariant,
                button: addToCartButton,
                quantity: parseInt(formData.get('quantity') || 1)
              }
            }));
            
            // Handle page redirect if needed
            if (window.theme && window.theme.cartType === 'page') {
              window.location.href = '/cart';
            }
          })
          .catch(error => {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            setButtonLoading(false);
            console.error('Error adding to cart:', error);
            alert('There was an error adding items to your cart. Please try again.');
          });
        }
        return;
      }
      
      // Set button to loading state
      setButtonLoading(true);
      
      // Continue with adding selected accessories and/or warranty
      const selectedAccessories = Array.from(checkboxes)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => ({
          id: checkbox.value,
          quantity: 1
        }));

      // Add main product to cart first
      const formData = new FormData(productForm);
      const mainProductData = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity') || 1)
      };

      // Calculate total quantity (main product + accessories + warranty if selected)
      const totalQuantity = mainProductData.quantity + selectedAccessories.length + (selectedWarranty ? 1 : 0);

      // Dispatch loading start
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      // Add main product
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(mainProductData)
      })
      .then(response => response.json())
      .then(() => {
        // Add selected warranty first (if selected)
        const promises = [];
        if (selectedWarranty) {
          promises.push(
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(selectedWarranty)
            }).then(response => response.json())
          );
        }
        
        // Add selected accessories
        if (selectedAccessories.length > 0) {
          const accessoryPromises = selectedAccessories.map(accessory => 
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(accessory)
            }).then(response => response.json())
          );
          promises.push(...accessoryPromises);
        }

        return Promise.all(promises);
      })
      .then(() => {
        // Dispatch loading end
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        
        // Deselect all checkboxes and warranty radios
        checkboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
        warrantyRadios.forEach(radio => {
          radio.checked = false;
        });
        updateButtonState();
        
        // Close the accessories modal first
        modal.close();
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('is-locked');
        shouldShowModal = false;
        
        // Get current variant from variant picker script tag or form ID
        let currentVariant = null;
        const variantPicker = productForm.querySelector('variant-picker');
        if (variantPicker) {
          const variantScript = variantPicker.querySelector('script[data-variant]');
          if (variantScript) {
            try {
              currentVariant = JSON.parse(variantScript.textContent);
            } catch (e) {
              // Fallback to variant ID from form
              const variantId = formData.get('id');
              currentVariant = variantId ? { id: parseInt(variantId) } : null;
            }
          }
        } else {
          // Fallback: get variant ID from form
          const variantId = formData.get('id');
          currentVariant = variantId ? { id: parseInt(variantId) } : null;
        }
        
        // Dispatch product:added event from productFormElement so it bubbles properly
        // The Cart class listens for this event and handles cart refresh + drawer opening
        productFormElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: currentVariant,
            button: addToCartButton,
            quantity: totalQuantity
          }
        }));
        
        // Handle page redirect if needed
        if (window.theme && window.theme.cartType === 'page') {
          window.location.href = '/cart';
        }
      })
      .catch(error => {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        setButtonLoading(false);
        console.error('Error adding to cart:', error);
        alert('There was an error adding items to your cart. Please try again.');
      });
    });
  }

  // Handle modal close button
  const closeButton = modal.querySelector('.modal__close[data-action="close-modal"]');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      modal.close();
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('is-locked');
    });
  }

  // Handle clicking outside modal
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      modal.close();
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('is-locked');
    }
  });
})();
